site.megamenu = {
	init:function() {
		var $body = $('body');
		var $mainmenu = $('#mainmenu');
		if ($(document).width()+15 >= 992) {
			$('.mmLevel2', $mainmenu).wrap('<div class="megamenu"><div class="wrap"><div class="contentWrap" /></div></div>');
			$('.megamenu .contentWrap').append('<div class="extra" />');
		}

		/*$mainmenu.on('click touchstart', function(e) {
			e.stopPropagation();
		});*/

		$('.level1.children > a',$mainmenu).on('click touchstart', function (e) {
			if ($(document).width()+15 >= 992) {
				e.preventDefault();
				e.stopPropagation();

				//Click on node that is already open
				if ($(this).parent().hasClass('open')) {
					site.megamenu.close();
				}
				//Open megamenu
				else {
					site.headSearch.close(true);
					$('.level1.open', $mainmenu).removeClass('open');
					$('.megamenu', $mainmenu).removeAttr('style');
					$(this).parent().addClass('open');
					site.megamenu.setHeight();

					if (!$body.hasClass('megamenu-open')) {
						$body.addClass('megamenu-opening');

						setTimeout(function() {
							$body.removeClass('megamenu-opening');
							if (!$body.is('.megamenu-closing')) {
								$body.addClass('megamenu-open');
							}
						},600);
					}
				}
			}
		});

		$('.mmLevel2 .si > a',$mainmenu).mouseenter(function() {
			var $li = $(this).closest('li');
			$('.hover__current').removeClass('hover__current');
			$li.addClass('hover__current');
			site.megamenu.getExtraContents($li);
		});

		$('.level2.children:not(.hideMenu) > a', $mainmenu).on('click touchstart', function (e) {
			if ($(document).width()+15 >= 992) {
				e.preventDefault();
				e.stopPropagation();

				if ($(this).parent().siblings().children('ul').hasClass('open')) {
					$(this).parent().siblings().children('ul').removeClass('open');
				}

				if($(this).siblings('ul').hasClass('open')) {
					$(this).siblings('ul').removeClass('open');
				}
				else {
					$(this).siblings('ul').addClass('open');
				}

				if ($(this).parent().siblings('li').hasClass('selected')) {
					$(this).parent().siblings('li').removeClass('selected');
				}

				if($(this).parent().hasClass('selected')) {
					$(this).parent().removeClass('selected');
				}
				else {
					$(this).parent().addClass('selected');
				}
			}
		});

		$('body').on('click touchstart', function (e) {
			if ($body.is('.megamenu-open')) {
				site.megamenu.close();
			}
		});

		$(window).resize(function() {
			site.megamenu.setHeight();
		});

		site.megamenu.loadExtraContents();
		site.megamenu.sections();
	},

	setHeight:function() {
		var $megamenu = $('.megamenu', '#mainmenu .level1.open');
		if ($megamenu.length > 0) {
			var $megamenuHeight = 470;
			$megamenu.css('max-height', $megamenuHeight);
			$('#pageContainer').css('min-height', $megamenuHeight+142);
		}
	},
	close:function() {
		var $body = $('body'),
			$mainmenu = $('#mainmenu');
		$('.megamenu', $mainmenu).removeAttr('style');
		$('.level1.open', $mainmenu).removeClass('open');
		$('#pageContainer').removeAttr('style');

		if ($body.hasClass('megamenu-open')) {
			$body.addClass('megamenu-closing');
			setTimeout(function() {
				$body.removeClass('megamenu-closing');
			},600);
		}
		$body.removeClass('megamenu-open');
	},

	currentContent: null,
	extraContents: null,
	loadExtraContents: function() {
		if (!site.megamenu.extraContents) {
			$.ajax({
				type: 'GET',
				'url': '/_/moya/html/ajax/sitemapExtra/',
				'dataType': 'json',
				success: function (r) {
					site.megamenu.extraContents = r;
				},
				complete: function (response) {
					if(response.status === 200) {
						$('.mmLevel1 >.children').each(function () {
							site.megamenu.getExtraContents($(this));
						});
					}
				}
			});
		}
		return site.megamenu.extraContents;
	},

	getExtraContents: function($node) {
		var content = site.megamenu.extraContents[site.megamenu.getSelectorFromNode($node)];
		if (!content) {
			var $parent = $node.closest('.level1');
			content = site.megamenu.extraContents[site.megamenu.getSelectorFromNode($parent)];
		}
		if(content !== site.megamenu.currentContent){
			if($node.closest('.megamenu').length > 0) {
				$node.closest('.megamenu').find('.extra').hide(0, function() {
					$(this).html(content).show(6);
				});
			}
			else {
				$node.find('.megamenu .extra').hide(0, function() {
					$(this).html(content).show(6);
				});
			}
			site.megamenu.currentContent = content;
		}

	},

	getSelectorFromNode: function($node) {
		var classes = $node.attr('class'),
			codename = classes.match(/\bele\-([^\s]+)/)[1],
			level = classes.match(/level([0-9])/)[1];
		return codename + '-' + (parseInt(level) + 1);
	},

	sections: function() {
		var $body = $('body');

		var $sections = $('.sections__details'),
			$extra = $('.extra .section__overview', $sections),
			extraHeight = 0;
		$('.mmLevel3 .si > a', $sections).click(function(e) {
			e.preventDefault();
			var $li = $(this).closest('li');
			$('.hover__current').removeClass('hover__current');
			$li.addClass('hover__current');
			site.megamenu.getExtraAboutContents($li);

			if($body.is('.frontpage')) {
				setTimeout(function() {
					if ($body.width() > 768) {
						let extraHeight = ($('.sections__details .extra').outerHeight() + 30);
						$('.box_sections').css('height', extraHeight);

					}
					else {
						let extraHeight = ($('.sections__details .extra').outerHeight() + 30);
					}



				}, 401);
			}

			if ($body.width() > 768) {
				var currentExtraHeight = $extra.scrollHeight;
				if (currentExtraHeight > extraHeight) {
					extraHeight = currentExtraHeight;
					$sections.height(extraHeight);
				}
			}
		});
		if($body.is('.frontpage')) {
			let heightInit = ($('.sections__details .extra').outerHeight() + 30);
			$('.box_sections').css('min-height', heightInit);
		}

		$(window).resize(function () {
			extraHeight = 0;
			$sections.removeAttr('style');
		});

		site.megamenu.appendMapHoverLinks();
	},

	currentOnepagerContent: null,

	getExtraAboutContents: function($node) {
		var content = site.megamenu.extraContents[site.megamenu.getSelectorFromNode($node)];
		if (!content) {
			content = '';
		}
		if (content !== site.megamenu.currentOnepagerContent) {
			if ($node.closest('.sections__details').length > 0) {
				$node.closest('.sections__details').find('.extra').hide(5, function() {
					$(this).html(content).show(5);
				});
			}
			else {
				$node.find('.sections__details .extra').hide(5, function() {
					$(this).html(content).show(5);
				});
			}
			site.megamenu.currentOnepagerContent = content;

			setTimeout(function() {
				site.megamenu.appendMapHoverLinks();
			}, 400);
		}

	},

	appendMapHoverLinks: function() {
		var $menu = $('.sections__details ul.mmLevel3').clone().removeClass('mmLevel3').addClass('hoverMenu');
		$menu.appendTo('.sections__details .section__overview .image');

		$('.hoverMenu a').click(function(e) {
			e.preventDefault();
			var $li = $(this).closest('li');
			var $liClass = $(this).closest('li').attr('class').split(' ')[0];
			site.megamenu.getExtraAboutContents($li);

			var $menuItem = $('.sections__details ul.mmLevel3').find('.' + $liClass);
			$('>a', $menuItem).trigger('mouseenter');
		});
	}
};

site.inits.push('site.megamenu.init()');
